import { Component } from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'qpoint-special-attention',
    templateUrl: './special-attention.component.html',
    styleUrls: ['./special-attention.component.scss'],
    imports: [NgIf, NgTemplateOutlet]
})
export class SpecialAttentionComponent {

  public dataItem;
  public templateRef: any;
  public closePopup: () => unknown;

  public closeCallback() {
    return () => {
      this.closePopup();
    };
  }
}
